import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApplicationConfig } from 'app/config/ApplicationConfig';
import { Constant } from 'app/common/Constant';
import { ApplicationModel } from 'app/model/ApplicationModel';
import { LocaleService } from '@service/LocaleService';

@Injectable()
export class AppAcceptLanguageInterceptor implements HttpInterceptor {

  constructor(private localeService: LocaleService) {
  }

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.method && (request.url?.indexOf(ApplicationConfig.apiUrl) > -1)) {
      const appLanguageRequest: HttpRequest<any> = request.clone({
        setHeaders: {
          [Constant.HTTP_APP_ACCEPT_LANGUAGE_HEADER]: this.localeService.language$.getValue()
        }
      });
      return next.handle(appLanguageRequest);
    }
    else {
      return next.handle(request);
    }
  }
}
